import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FanNewsStory } from '../fan-news/fan-news.model';

export interface FanNewsListDialogData {
  stories: FanNewsStory[];
  sourceName: string;
}

// "Latest from uReport" pop-up (specs/ai-agent-home-redesign US-19), opened by the v2 news card's
// Show. The list, its auto-scroll and click-to-open-story come from FanNewsCardComponent
// (design="popup").
@Component({
  selector: 'app-fan-news-list-dialog',
  templateUrl: './fan-news-list-dialog.component.html',
  styleUrls: ['./fan-news-list-dialog.component.scss'],
})
export class FanNewsListDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<FanNewsListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FanNewsListDialogData
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
